// import PostFlightReportingService from "../../../../services/IpadPreview/AfterLanding/postflightreporting.service";

const state = {

    // FueljsonData: [],
    // samplevalue : "",

};
const mutations = {

    // set_json_data(state, payload) {
    //     state.FueljsonData = payload;
    //     state.samplevalue = "test";
    // }

};
const actions = {

    // async getJsonDataFuel({commit},{FKey1,TableCode}){
    //     const  jsonData = await  PostFlightReportingService.getJsonData(FKey1,TableCode);
    //     await  commit("set_json_data",jsonData);
    //     return  jsonData;
    // },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
